import React, { useState } from 'react';
import { ErrorDetails, sendErrorDetails } from '@unifocus/js-utils';
import { ErrorReportingModal } from './ErrorReportingModal';

export interface ErrorReportProperties {
   errorDetails: ErrorDetails;
   onErrorAcknowledged?: () => void;
}

export interface ErrorReportState {
   visible: boolean;
}

export const ErrorReport = (props: ErrorReportProperties) => {
   const [visible, setVisible] = useState(true);

   const cancelIconTapHandler = (): void => {
      setVisible(false);

      if (props.onErrorAcknowledged) {
         props.onErrorAcknowledged();
      }
   };

   const errorReportCancelHandler = (): void => {
      setVisible(false);

      if (props.onErrorAcknowledged) {
         props.onErrorAcknowledged();
      }
   };

   const errorReportSendHandler = (): void => {
      setVisible(false);

      sendErrorDetails(props.errorDetails);

      if (props.onErrorAcknowledged) {
         props.onErrorAcknowledged();
      }
   };

   return (
      <ErrorReportingModal
         visible={visible}
         cancelIconTapHandler={cancelIconTapHandler}
         errorReportCancelHandler={errorReportCancelHandler}
         errorReportSendHandler={errorReportSendHandler}
         errorDetails={props.errorDetails}
      />
   );
};
